import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { useError } from '../../../field-error';
import { useFieldAttributes } from '../../../services/field-attributes';
import { DateFieldWUT } from '../../../ui/date-field';
import { getDateFieldError, getDatePartsErrors, getDateValidationErrorSuffix } from '../../../ui/date-field/date-field-utils';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
export const ContactsBirthdateWUT = props => {
  const {
    id,
    description,
    validation,
    target,
    value,
    error,
    hideLabel,
    required,
    label,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    FieldLayout
  } = props;
  const dateFieldError = getDateFieldError(validation, error, value ?? '');
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, dateFieldError, description);
  const fieldType = FIELD_TYPES.CONTACTS_BIRTHDATE;
  const {
    errorMessage,
    hasError
  } = useError(dateFieldError, undefined, fieldType, getDateValidationErrorSuffix(dateFieldError));

  // FixMe: Temporary fallback, once we migrate all the forms we can remove both the fallback and the property
  const hidePlaceholder = props.hidePlaceholder ?? props.placeholder === 'none';
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => /*#__PURE__*/React.createElement(DateFieldWUT, _extends({}, props, {
      errors: getDatePartsErrors(hasError, value ?? ''),
      hidePlaceholder: hidePlaceholder,
      inputId: inputId,
      ariaLabelledBy: labelId,
      value: value,
      ariaDescribedBy: ariaDescribedBy
    })),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=contacts-birthdate-wut.js.map